import { createRouter, createWebHistory } from 'vue-router';
import ListProduct from './pages/product/ListProduct.vue';
import ImportProduct from './pages/product/ImportProduct.vue';
import UpdateProduct from './pages/product/UpdateProduct.vue';
import ImportProductCost from './pages/product/ImportProductCost.vue';
import ImportEstimatedShippingFee from './pages/product/ImportEstimatedShippingFee.vue';
import ListMarketplaceOrder from './pages/marketplaceOrder/ListMarketplaceOrder.vue';
import ImportMarketplaceOrder from './pages/marketplaceOrder/ImportMarketplaceOrder.vue';
import UpdateMarketplaceOrder from './pages/marketplaceOrder/UpdateMarketplaceOrder.vue';
import ImportMarketplaceOrderItem from './pages/marketplaceOrder/ImportMarketplaceOrderItem.vue';
import ImportShippingFee from './pages/marketplaceOrder/ImportShippingFee.vue';
import ListCurrencyRate from './pages/currencyRate/ListCurrencyRate.vue';
import ImportCurrencyRate from './pages/currencyRate/ImportCurrencyRate.vue';
import CalculateGrossProfit from './pages/grossProfit/CalculateGrossProfit.vue';
import ListGrossProfit from './pages/grossProfit/ListGrossProfit.vue';
import ListRefund from './pages/refund/ListRefund.vue';
import ImportRefund from './pages/refund/ImportRefund.vue';
import SignIn from './pages/SignIn.vue';
import ForgotPassword from './pages/ForgotPassword.vue';
import Home from './pages/Home.vue';
import Account from './pages/Account.vue';
import { useAuthStore } from './stores/AuthStore';
import { PathDefinition } from './utils/PathDefinition';
import ListPayment from './pages/payment/ListPayment.vue';
import ImportPayment from './pages/payment/ImportPayment.vue';
import ListTransaction from './pages/transaction/ListTransaction.vue';
import GenerateTransaction from './pages/transaction/GenerateTransaction.vue';
import MasterData from './pages/masterData/MasterData.vue';
import CreateMasterData from './pages/masterData/CreateMasterData.vue';
import ImportMasterData from './pages/masterData/ImportMasterData.vue';
import UpdateMasterData from './pages/masterData/UpdateMasterData.vue';

const routes = [
    {
        path: PathDefinition.home,
        name: 'Home',
        component: Home,
        meta: { layout: 'DefaultLayout' }
    },
    {
        path: PathDefinition.account,
        name: 'Account',
        component: Account,
        meta: { layout: 'DefaultLayout' }
    },
    {
        path: PathDefinition.masterData,
        name: 'MasterData',
        component: MasterData,
        meta: { layout: 'DefaultLayout' }
    },
    {
        path: PathDefinition.createMasterData,
        name: 'CreateMasterData',
        component: CreateMasterData,
        meta: { layout: 'DefaultLayout' }
    },
    {
        path: PathDefinition.importMasterData,
        name: 'ImportMasterData',
        component: ImportMasterData,
        meta: { layout: 'DefaultLayout' }
    },
    {
        path: PathDefinition.updateMasterData,
        name: 'UpdateMasterData',
        component: UpdateMasterData,
        meta: { layout: 'DefaultLayout' }
    },
    {
        path: PathDefinition.signIn,
        name: 'SignIn',
        component: SignIn,
        meta: { layout: 'BlankLayout' }
    },
    {
        path: PathDefinition.forgotPassword,
        name: 'ForgotPassword',
        component: ForgotPassword,
        meta: { layout: 'BlankLayout' }
    },
    {
        path: PathDefinition.listProduct,
        name: 'ListProduct',
        component: ListProduct,
        meta: { layout: 'DefaultLayout' }
    },
    {
        path: PathDefinition.importProduct,
        name: 'ImportProduct',
        component: ImportProduct,
        meta: { layout: 'DefaultLayout' }
    },
    {
        path: PathDefinition.updateProduct,
        name: 'UpdateProduct',
        component: UpdateProduct,
        meta: { layout: 'DefaultLayout' }
    },
    {
        path: PathDefinition.importProductCost,
        name: 'ImportProductCost',
        component: ImportProductCost,
        meta: { layout: 'DefaultLayout' }
    },
    {
        path: PathDefinition.importEstimatedShippingFee,
        name: 'ImportEstimatedShippingFee',
        component: ImportEstimatedShippingFee,
        meta: { layout: 'DefaultLayout' }
    },
    {
        path: PathDefinition.listMarketplaceOrder,
        name: 'ListMarketplaceOrder',
        component: ListMarketplaceOrder,
        meta: { layout: 'DefaultLayout' }
    },
    {
        path: PathDefinition.importMarketplaceOrder,
        name: 'ImportMarketplaceOrder',
        component: ImportMarketplaceOrder,
        meta: { layout: 'DefaultLayout' }
    },
    {
        path: PathDefinition.updateMarketplaceOrder,
        name: 'UpdateMarketplaceOrder',
        component: UpdateMarketplaceOrder,
        meta: { layout: 'DefaultLayout' }
    },
    {
        path: PathDefinition.importMarketplaceOrderItem,
        name: 'ImportMarketplaceOrderItem',
        component: ImportMarketplaceOrderItem,
        meta: { layout: 'DefaultLayout' }
    },
    {
        path: PathDefinition.importShippingFee,
        name: 'ImportShippingFee',
        component: ImportShippingFee,
        meta: { layout: 'DefaultLayout' }
    },
    {
        path: PathDefinition.listCurrencyRate,
        name: 'ListCurrencyRate',
        component: ListCurrencyRate,
        meta: { layout: 'DefaultLayout' }
    },
    {
        path: PathDefinition.importCurrencyRate,
        name: 'ImportCurrencyRate',
        component: ImportCurrencyRate,
        meta: { layout: 'DefaultLayout' }
    },
    {
        path: PathDefinition.calculateGrossProfit,
        name: 'CalculateGrossProfit',
        component: CalculateGrossProfit,
        meta: { layout: 'DefaultLayout' }
    },
    {
        path: PathDefinition.listGrossProfit,
        name: 'ListGrossProfit',
        component: ListGrossProfit,
        meta: { layout: 'DefaultLayout' }
    },
    {
        path: PathDefinition.listRefund,
        name: 'ListRefund',
        component: ListRefund,
        meta: { layout: 'DefaultLayout' }
    },
    {
        path: PathDefinition.importRefund,
        name: 'ImportRefund',
        component: ImportRefund,
        meta: { layout: 'DefaultLayout' }
    },
    {
        path: PathDefinition.listPayment,
        name: 'ListPayment',
        component: ListPayment,
        meta: { layout: 'DefaultLayout' }
    },
    {
        path: PathDefinition.importPayment,
        name: 'ImportPayment',
        component: ImportPayment,
        meta: { layout: 'DefaultLayout' }
    },
    {
        path: PathDefinition.listTransaction,
        name: 'ListTransaction',
        component: ListTransaction,
        meta: { layout: 'DefaultLayout' }
    },
    {
        path: PathDefinition.generateTransaction,
        name: 'GenerateTransaction',
        component: GenerateTransaction,
        meta: { layout: 'DefaultLayout' }
    }
];

const router = createRouter({ history: createWebHistory(), routes });

router.beforeEach(async (to) => {
    const publicPages = [PathDefinition.signIn, PathDefinition.forgotPassword];
    const authRequired = !publicPages.includes(to.path);
    const auth = useAuthStore();

    if (authRequired) {
        const authenticated = await auth.isAuthenticated();
        if (!authenticated) {
            auth.returnUrl = to.fullPath;
            return PathDefinition.signIn;
        }
    }
});
export default router;
